import { get, startCase, uniqueId } from "lodash";
import {
  ILayoutSettings,
  PageSectionCategory,
} from "@launchos/plugins/misc/v2/blocks/weblayouts/types";
import { ComponentTypes } from "@launchos/plugins/webcomponents/types";
import { ContentLayouts } from "@launchos/plugins/misc/v2/blocks/weblayouts/Content/types";
import { combineData, lorem } from "../../utils";
import { default as defaultData } from "./data.json";
import { style } from "./style";
import {
  getImagePlaceholder,
  ImagePlaceholderTypes,
  getVideoPlaceholder,
  VideoPlaceholderTypes,
} from "../../Placeholders";
import theme from "../../theme";

const content = combineData(defaultData);

const settings: ILayoutSettings = {
  label: ContentLayouts.FIVE,
  layout: ContentLayouts.FIVE,
  previewImage:
    "https://sandcastleassets.s3.amazonaws.com/blocks/content/Content05.png",
  loadFromExt: true,
  loadFromExtSettings: {
    pageId: "ckky7r33x28f507806a3vy0ss",
    itemId: "8hy9xt8mbkx",
  },
  default: {
    type: ComponentTypes.SECTION,
    label: PageSectionCategory.CONTENT,
    bodyOnly: true,
    canHaveChildren: false,
    properties: {
      ...style.SECTION,
      ...style.SECTION_INNER,
    },
    children: [
      {
        type: ComponentTypes.COLUMNS,
        canHaveChildren: false,
        properties: {
          width: "100%",
        },
        children: [
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((5 * 100) / 12),
            properties: { height: "100%", padding: 20, minHeight: 20 },
            children: [
              {
                type: ComponentTypes.HEADLINE,
                canHaveChildren: false,
                properties: {
                  ...style.HEADLINE,
                },
                html:
                  "Free report reveals how to get the most out of your ability to  include actual images.",
              },
            ],
          },
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((7 * 100) / 12),
            properties: { height: "100%", padding: 20, minHeight: 20 },
            children: [
              {
                type: ComponentTypes.TEXT,
                canHaveChildren: false,
                properties: {
                  ...style.TEXT,
                },
                html:
                  "It's true.  Getting results is much easier than you think.  The truth is most people simply don't know the correct steps to take so they become frustrated and quit.",
              },
              {
                type: ComponentTypes.COLUMNS,
                canHaveChildren: false,
                properties: {
                  width: "100%",
                },
                children: [
                  {
                    type: ComponentTypes.COLUMN,
                    canHaveChildren: true,
                    preventDelete: true,
                    md: parseInt((6 * 100) / 12),
                    properties: { height: "100%", padding: 0, minHeight: 20 },
                    children: [
                      {
                        type: ComponentTypes.HEADLINE,
                        canHaveChildren: false,
                        properties: {
                          ...style.HEADLINE,
                          fontSize: "16pt",
                        },
                        html: "Headline Here",
                      },
                      {
                        type: ComponentTypes.CONTAINER,
                        canHaveChildren: true,
                        properties: {
                          ...style.LIST,
                        },
                        children: [
                          {
                            type: ComponentTypes.LISTITEM,
                            canHaveChildren: false,
                            properties: style.LI,
                            html: "Lorem",
                          },
                          {
                            type: ComponentTypes.LISTITEM,
                            canHaveChildren: false,
                            properties: style.LI,
                            html: "Ipsum",
                          },
                          {
                            type: ComponentTypes.LISTITEM,
                            canHaveChildren: false,
                            properties: style.LI,
                            html: "Dolor",
                          },
                        ],
                      },
                    ],
                  },
                  {
                    type: ComponentTypes.COLUMN,
                    canHaveChildren: true,
                    preventDelete: true,
                    md: parseInt((6 * 100) / 12),
                    properties: { height: "100%", padding: 0, minHeight: 20 },
                    children: [
                      {
                        type: ComponentTypes.HEADLINE,
                        canHaveChildren: false,
                        properties: {
                          ...style.HEADLINE,
                          fontSize: "16pt",
                        },
                        html: "Headline Here",
                      },
                      {
                        type: ComponentTypes.CONTAINER,
                        canHaveChildren: true,
                        properties: {
                          ...style.LIST,
                        },
                        children: [
                          {
                            type: ComponentTypes.LISTITEM,
                            canHaveChildren: false,
                            properties: style.LI,
                            html: "Ipsum",
                          },
                          {
                            type: ComponentTypes.LISTITEM,
                            canHaveChildren: false,
                            properties: style.LI,
                            html: "Dolor",
                          },
                          {
                            type: ComponentTypes.LISTITEM,
                            canHaveChildren: false,
                            properties: style.LI,
                            html: "Lorem",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default settings;
